import { Phone, Mail } from "lucide-react";
import { PHONE, PHONE_TEL, EMAIL } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#071223] text-slate-300 pt-16 pb-8"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <p className="font-heading text-2xl font-extrabold text-white">
              NZ&nbsp;<span className="text-[#0077E6]">CLEAN</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Professionelle Reinigung in Leonberg und Umgebung
            </p>
            <p className="mt-3 text-sm italic text-[#5CB3FF]">
              Glanz im Haus – Schmutz hinaus.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Kontakt
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${PHONE_TEL}`}
                  data-testid="footer-phone"
                  className="flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Phone className="h-4 w-4 text-[#0077E6]" />
                  {PHONE}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="footer-email"
                  className="flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Mail className="h-4 w-4 text-[#0077E6]" />
                  {EMAIL}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Rechtliches
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="#"
                  data-testid="footer-impressum"
                  className="hover:text-white transition-colors"
                >
                  Impressum
                </a>
              </li>
              <li>
                <a
                  href="#"
                  data-testid="footer-datenschutz"
                  className="hover:text-white transition-colors"
                >
                  Datenschutz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} NZ Clean. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};
